import Decimal from "decimal.js-light";
import "./StopUnitContent.scss";

const StopUnitContent = (props: {
  unit: {
    quantity: Decimal | null;
    name: string;
    description: string | null;
    weight: Decimal | null;
    length: Decimal | null;
    width: Decimal | null;
    height: Decimal | null;
    volume: Decimal | null;
    colli: Decimal | null;
  };
}) => {
  const { unit } = props;
  return (
    <>
      <div className="stop-unit-template-line-row-cell">
        {unit.quantity?.toString()}
      </div>
      <div className="stop-unit-template-line-row-cell">{unit.name}</div>
      <div className="stop-unit-template-line-row-cell">{unit.description}</div>
      <div className="stop-unit-template-line-row-cell">
        {unit.colli && unit.colli.toString()}
      </div>
      <div className="stop-unit-template-line-row-cell">
        {unit.weight && <>{unit.weight.toString()} kg</>}
      </div>
      <div className="stop-unit-template-line-row-cell">
        {unit.length?.toString() || "-"} x {unit.width?.toString() || "-"} x{" "}
        {unit.height?.toString() || "-"}
      </div>
      <div className="stop-unit-template-line-row-cell">
        {unit.volume && (
          <>
            {unit.volume.toString()} m<sup>3</sup>
          </>
        )}
      </div>
    </>
  );
};

export default StopUnitContent;
